// src/pages/orders/orderHistoryScreen/hooks/useOrderHistory.ts
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { OrderStatus } from "../../../../common/types/enums";
import { selectOrders } from "../../../../store/slices/orderSlice";
import { getOrderStatusIcon } from "../../../../common/utils/functions/enumToIcon";
import {
  getOrderStatusText,
  getStatusColor,
  getStatusTextColor,
} from "../../../../common/utils/functions/enumToText";

export const useOrderHistory = () => {
  const orders = useSelector(selectOrders);
  const [activeTab, setActiveTab] = useState<"all" | "active" | "completed">(
    "all",
  );

  const getOrderStatusInfo = useCallback((status: OrderStatus) => {
    return {
      text: getOrderStatusText(status),
      icon: getOrderStatusIcon(status),
      backgroundColor: getStatusColor(status),
      textColor: getStatusTextColor(status),
    };
  }, []);

  const filteredOrders = orders.filter((order) => {
    if (activeTab === "active") {
      return [
        OrderStatus.NEW,
        OrderStatus.PREPARING,
        OrderStatus.READY,
        OrderStatus.DELIVERING,
      ].includes(order.status);
    }
    if (activeTab === "completed") {
      return [
        OrderStatus.PICKED_UP,
        OrderStatus.DELIVERED,
        OrderStatus.CANCELLED,
      ].includes(order.status);
    }
    return true;
  });

  return {
    orders: filteredOrders,
    activeTab,
    setActiveTab,
    getStatusColor,
    getStatusTextColor,
    getOrderStatusInfo,
  };
};
